import React, { useEffect, useState } from 'react';
import { CheckCircle2, XCircle, ChevronDown, ChevronUp, Star, Clock, ShieldCheck, Zap, Settings, FileText, Gift, AlertTriangle } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const CHECKOUT_LINK = 'https://checkout.ebookpoint.shop/cart/59715489038417:1';
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/2ZkezHR35w35d2iq8Q7rxd/ChatGPT_Image_Jun_26,_2026,_06_10_17_PM.png';
const AccordionItem = ({
  title,
  children,
  icon: Icon
}: {
  title: string;
  children: React.ReactNode;
  icon?: any;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-lg mb-3 bg-white overflow-hidden shadow-sm" data-id="element-20">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-4 text-left font-semibold text-gray-800 hover:bg-gray-50 transition-colors" data-id="element-21">
        <div className="flex items-center gap-3" data-id="element-22">
          {Icon && <Icon className="w-5 h-5 text-blue-600" data-id="element-23" />}
          <span data-id="element-24">{title}</span>
        </div>
        {isOpen ? <ChevronUp className="w-5 h-5 text-gray-500" data-id="element-25" /> : <ChevronDown className="w-5 h-5 text-gray-500" data-id="element-26" />}
      </button>
      {isOpen && <div className="p-4 bg-gray-50 border-t border-gray-100 text-gray-700" data-id="element-27">
          {children}
        </div>}
    </div>;
};
const BuyButton = ({
  text = 'QUIERO RECUPERAR MIS HORAS'
}: {
  text?: string;
}) => <a href={CHECKOUT_LINK} className="block w-full max-w-md mx-auto bg-green-500 hover:bg-green-600 text-white text-center font-bold py-4 px-8 rounded-full shadow-[0_4px_14px_0_rgba(34,197,94,0.39)] hover:shadow-[0_6px_20px_rgba(34,197,94,0.23)] hover:-translate-y-1 transition-all duration-200 text-lg uppercase tracking-wide" data-id="element-28">
    {text}
  </a>;
export function SalesPage() {
  return <div className="min-h-screen bg-gray-50 font-sans text-gray-900 pb-20" data-id="element-29">
      <main className="max-w-3xl mx-auto px-4 pt-8" data-id="element-30">
        {/* Hero Section */}
        <section className="text-center mb-12" data-id="element-31">
          <h1 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-6 leading-tight" data-id="element-32">
            Dejá de perder 15 horas por semana cargando planillas a mano
          </h1>

          <a href={CHECKOUT_LINK} className="block mb-6 cursor-pointer hover:opacity-95 transition-opacity" data-id="element-33">
            <img src={MAIN_IMAGE} alt="Kit Contador Ágil" className="w-[85%] max-w-2xl mx-auto rounded-xl shadow-2xl" data-id="element-34" />
          </a>

          <h2 className="text-base md:text-lg font-medium text-gray-700 mb-6 leading-snug max-w-xl mx-auto px-4" data-id="element-35">
            Kit completo de planillas automatizadas + 18 prompts de IA para que
            asesores clientes, no cargues datos.
          </h2>

          <div className="flex flex-wrap justify-center gap-4 mb-8 text-sm font-bold text-slate-700" data-id="element-36">
            <span className="flex items-center gap-1 bg-white px-3 py-1.5 rounded-full shadow-sm border border-gray-100" data-id="element-37">
              📄 100% PDF / Excel
            </span>
            <span className="flex items-center gap-1 bg-white px-3 py-1.5 rounded-full shadow-sm border border-gray-100" data-id="element-38">
              ⚡️ Entrega Inmediata
            </span>
            <span className="flex items-center gap-1 bg-white px-3 py-1.5 rounded-full shadow-sm border border-gray-100" data-id="element-39">
              4.9/5.0 ⭐️
            </span>
          </div>

          <BuyButton data-id="element-40" />
        </section>

        {/* Problems Section */}
        <section className="mb-16 bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-41">
          <h3 className="text-2xl font-bold text-center mb-6 text-slate-800" data-id="element-42">
            Probablemente te paso alguna de estas cosas 😬
          </h3>
          <div className="space-y-4" data-id="element-43">
            {['Pasas horas cargando comprobantes a mano uno por uno.', 'Te olvidas de los vencimientos o corres a último momento.', 'Tus planillas de Excel se rompen o están desactualizadas.', 'No te queda tiempo para asesorar y conseguir nuevos clientes.', 'Sientes que cobras poco para la cantidad de trabajo operativo que haces.'].map((problem, i) => <div key={i} className="flex items-start gap-3 bg-red-50 border border-red-100 rounded-lg p-3" data-id="element-44">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-45" />
                <p className="text-red-700 font-medium" data-id="element-46">{problem}</p>
              </div>)}
          </div>
        </section>

        {/* What's Included */}
        <section className="mb-16" data-id="element-47">
          <p className="text-center text-blue-600 font-semibold text-lg mb-2" data-id="element-48">
            Por eso creamos este Kit:
          </p>
          <h3 className="text-2xl font-bold text-center mb-8 text-slate-800" data-id="element-49">
            ¿Qué incluye el KIT Contador Ágil?
          </h3>

          <div className="space-y-2" data-id="element-50">
            <AccordionItem title="✅ Ebook completo — Sistema de automatización contable (7 módulos)" icon={FileText} data-id="element-51">
              <p data-id="element-52">
                Aprende paso a paso cómo estructurar tu estudio contable para
                que funcione en piloto automático. Desde la captación de
                clientes hasta la entrega de reportes.
              </p>
            </AccordionItem>

            <AccordionItem title="✅ 4 Planillas inteligentes que calculan solas" icon={Settings} data-id="element-53">
              <ul className="space-y-2 ml-2 mt-2" data-id="element-54">
                <li className="flex items-center gap-2" data-id="element-55">
                  <span data-id="element-56">📊</span> Calculadora de Recategorización de Monotributo
                </li>
                <li className="flex items-center gap-2" data-id="element-57">
                  <span data-id="element-58">💰</span> Liquidador de Sueldos
                </li>
                <li className="flex items-center gap-2" data-id="element-59">
                  <span data-id="element-60">📝</span> Control de IVA Compras/Ventas
                </li>
                <li className="flex items-center gap-2" data-id="element-61">
                  <span data-id="element-62">📅</span> Calendario Fiscal y Vencimientos
                </li>
              </ul>
            </AccordionItem>

            <AccordionItem title="✅ Biblioteca de 18 Prompts de IA exclusivos para contadores" icon={Zap} data-id="element-63">
              <p data-id="element-64">
                Copia y pega estos comandos en ChatGPT para redactar emails,
                analizar normativas, crear reportes y responder consultas de
                clientes en segundos.
              </p>
            </AccordionItem>

            <AccordionItem title="✅ Actualización trimestral de valores" icon={CheckCircle2} data-id="element-65">
              <p data-id="element-66">
                No te preocupes por la inflación. Te enviamos los valores
                actualizados de ARCA/AFIP cada trimestre.
              </p>
            </AccordionItem>

            <AccordionItem title="✅ 10 Modelos de Notas a ARCA ya redactados" icon={CheckCircle2} data-id="element-67">
              <p data-id="element-68">
                Plantillas listas para presentar descargos, contestar
                requerimientos y solicitar planes de pago.
              </p>
            </AccordionItem>

            <AccordionItem title="✅ Planilla de Honorarios y Cobranza" icon={CheckCircle2} data-id="element-69">
              <p data-id="element-70">
                Controla quién te pagó, quién te debe y calcula ajustes de
                honorarios automáticamente.
              </p>
            </AccordionItem>

            <AccordionItem title="✅ Ficha de Onboarding para Clientes Nuevos" icon={CheckCircle2} data-id="element-71">
              <p data-id="element-72">
                El formulario perfecto para pedirle toda la información inicial
                a un cliente sin idas y vueltas.
              </p>
            </AccordionItem>

            <AccordionItem title="✅ Informe Mensual para tus Clientes (Word + Google Sheets)" icon={CheckCircle2} data-id="element-73">
              <p data-id="element-74">
                Plantillas profesionales para entregar un resumen claro de
                impuestos y situación a tus clientes.
              </p>
            </AccordionItem>
          </div>
        </section>

        {/* Bonuses */}
        <section className="mb-16 bg-gradient-to-br from-blue-900 to-slate-900 p-6 md:p-8 rounded-2xl text-white shadow-xl" data-id="element-75">
          <div className="text-center mb-8" data-id="element-76">
            <h3 className="text-2xl font-bold mb-2 text-yellow-400" data-id="element-77">
              + 2 BONOS exclusivos
            </h3>
            <p className="text-blue-100" data-id="element-78">
              Gratis solo por el día de hoy con tu compra
            </p>
          </div>

          <div className="space-y-2 text-gray-900" data-id="element-79">
            <AccordionItem title="🎁 Glosario rápido de Prompts por Situación" icon={Gift} data-id="element-80">
              <p data-id="element-81">
                Una guía rápida para saber qué prompt usar según el problema que
                tengas que resolver.
              </p>
            </AccordionItem>
            <AccordionItem title="🎁 Mini guía 'Cómo cobrar más sin perder clientes'" icon={Gift} data-id="element-82">
              <p data-id="element-83">
                Estrategias probadas para aumentar tus honorarios comunicando el
                valor real de tu trabajo.
              </p>
            </AccordionItem>
          </div>
        </section>

        {/* Comparison Table */}
        <section className="mb-16" data-id="element-84">
          <h3 className="text-2xl font-bold text-center mb-8 text-slate-800" data-id="element-85">
            Sin KIT Contador Ágil vs Con KIT Contador Ágil
          </h3>
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-86">
            <div className="grid grid-cols-2 border-b border-gray-200" data-id="element-87">
              <div className="p-4 text-center font-bold text-white bg-red-600 border-r border-red-700" data-id="element-88">
                Sin el KIT ❌
              </div>
              <div className="p-4 text-center font-bold text-green-700 bg-green-50" data-id="element-89">
                Con el KIT ✅
              </div>
            </div>
            <div className="grid grid-cols-2 border-b border-gray-100" data-id="element-90">
              <div className="p-4 text-sm text-red-800 bg-red-50 border-r border-red-100" data-id="element-91">
                Carga manual de datos interminable
              </div>
              <div className="p-4 text-sm text-gray-800 font-medium bg-green-50/30" data-id="element-92">
                Fórmulas que calculan todo automáticamente
              </div>
            </div>
            <div className="grid grid-cols-2 border-b border-gray-100" data-id="element-93">
              <div className="p-4 text-sm text-red-800 bg-red-50 border-r border-red-100" data-id="element-94">
                Estrés por vencimientos cercanos
              </div>
              <div className="p-4 text-sm text-gray-800 font-medium bg-green-50/30" data-id="element-95">
                Calendario visual con alertas claras
              </div>
            </div>
            <div className="grid grid-cols-2 border-b border-gray-100" data-id="element-96">
              <div className="p-4 text-sm text-red-800 bg-red-50 border-r border-red-100" data-id="element-97">
                Redacción de emails y notas desde cero
              </div>
              <div className="p-4 text-sm text-gray-800 font-medium bg-green-50/30" data-id="element-98">
                Prompts de IA y plantillas listas para usar
              </div>
            </div>
            <div className="grid grid-cols-2" data-id="element-99">
              <div className="p-4 text-sm text-red-800 bg-red-50 border-r border-red-100" data-id="element-100">
                Poco tiempo para captar clientes
              </div>
              <div className="p-4 text-sm text-gray-800 font-medium bg-green-50/30" data-id="element-101">
                Horas libres para hacer crecer tu estudio
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="mb-16" data-id="element-102">
          <h3 className="text-2xl font-bold text-center mb-8 text-slate-800" data-id="element-103">
            Lo que dicen otros colegas
          </h3>
          <div className="grid gap-4 md:grid-cols-2" data-id="element-104">
            {[{
            name: 'Martín (34), CABA',
            text: 'Me ahorró literalmente 10 horas por semana. Las planillas son una locura.'
          }, {
            name: 'Laura (41), Córdoba',
            text: 'Por fin pude automatizar el IVA y los sueldos. Excelente inversión.'
          }, {
            name: 'Diego (29), Rosario',
            text: 'Los prompts de IA me volaron la cabeza. Ahora respondo consultas en segundos.'
          }, {
            name: 'Sofía (37), Mendoza',
            text: 'El mejor kit que compré. La calculadora de monotributo es súper exacta.'
          }, {
            name: 'Javier (45), La Plata',
            text: 'Pasé de estar tapado de papeles a tener todo organizado. Lo recomiendo 100%.'
          }].map((t, i) => <div key={i} className="bg-white p-5 rounded-xl shadow-sm border border-gray-100" data-id="element-105">
                <div className="flex text-yellow-400 mb-2" data-id="element-106">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-107" />)}
                </div>
                <p className="text-gray-700 italic mb-3" data-id="element-108">"{t.text}"</p>
                <p className="text-sm font-bold text-slate-900" data-id="element-109">{t.name}</p>
              </div>)}
          </div>
        </section>

        <p className="text-center text-xl md:text-2xl font-bold text-slate-900 mb-6" data-id="element-110">
          No pierdas más horas gratis, recuperalas con este Kit
        </p>

        {/* Urgency: countdown + cupos — ONLY above the final offer */}
        <section className="mb-6 bg-red-600 text-white px-4 py-4 rounded-2xl shadow-md" data-id="element-111">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6" data-id="element-112">
            <div className="flex flex-col items-center sm:items-start" data-id="element-113">
              <span className="flex items-center gap-1.5 text-sm font-bold uppercase tracking-wide" data-id="element-114">
                <AlertTriangle className="w-4 h-4" data-id="element-115" />
                La oferta termina en
              </span>
              <span className="text-xs text-white/90 mt-0.5" data-id="element-116">
                Solo quedan <span className="font-bold" data-id="element-117">17</span> de 200 cupos
              </span>
              <div className="w-full max-w-[220px] h-2.5 bg-red-800 rounded-full overflow-hidden mt-1.5" data-id="element-118">
                <div className="h-full bg-yellow-400 w-[8.5%]" data-id="element-119" />
              </div>
            </div>
            <CountdownTimer data-id="element-120" />
          </div>
        </section>

        {/* Final Offer */}
        <section className="mb-16 bg-white p-8 rounded-2xl shadow-xl border-2 border-blue-600 text-center relative overflow-hidden" data-id="element-121">
          <div className="absolute top-0 right-0 bg-red-600 text-white px-4 py-1 rounded-bl-lg font-bold text-sm" data-id="element-122">
            OFERTA LIMITADA
          </div>

          <h3 className="text-3xl font-extrabold text-slate-900 mb-2" data-id="element-123">
            Esto es todo lo que te llevás hoy
          </h3>
          <p className="text-gray-500 mb-6" data-id="element-124">
            Acceso inmediato y de por vida a todo el sistema:
          </p>

          {/* Full summary of what the client gets */}
          <ul className="text-left max-w-md mx-auto space-y-3 mb-8" data-id="element-125">
            {['Ebook completo — Sistema de automatización contable (7 módulos)', '4 Planillas inteligentes que calculan solas', 'Biblioteca de 18 Prompts de IA exclusivos', 'Actualización trimestral de valores', '10 Modelos de Notas a ARCA ya redactados', 'Planilla de Honorarios y Cobranza', 'Ficha de Onboarding para Clientes Nuevos', 'Informe Mensual para tus Clientes (Word + Google Sheets)'].map(item => <li key={item} className="flex items-start gap-3" data-id="element-126">
                <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-127" />
                <span className="text-gray-800 font-medium" data-id="element-128">{item}</span>
              </li>)}
            {['BONO: Glosario rápido de Prompts por Situación', "BONO: Mini guía 'Cómo cobrar más sin perder clientes'"].map(item => <li key={item} className="flex items-start gap-3" data-id="element-129">
                <Gift className="w-5 h-5 text-yellow-500 flex-shrink-0 mt-0.5" data-id="element-130" />
                <span className="text-gray-800 font-medium" data-id="element-131">{item}</span>
              </li>)}
          </ul>

          <div className="mb-6" data-id="element-132">
            <p className="text-gray-500 line-through text-xl mb-1" data-id="element-133">
              Precio normal: $59.900
            </p>
            <p className="text-5xl font-black text-green-600 mb-2" data-id="element-134">
              $19.990{' '}
              <span className="text-lg text-gray-600 font-normal" data-id="element-135">ARS</span>
            </p>
            <p className="text-sm font-medium text-blue-600 bg-blue-50 inline-block px-3 py-1 rounded-full" data-id="element-136">
              Incluye los 2 bonos GRATIS
            </p>
          </div>

          <BuyButton data-id="element-137" />

          <div className="mt-6 flex justify-center items-center gap-4 text-sm text-gray-500" data-id="element-138">
            <span className="flex items-center gap-1" data-id="element-139">
              <ShieldCheck className="w-4 h-4" data-id="element-140" /> Pago Seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-141">
              <Clock className="w-4 h-4" data-id="element-142" /> Acceso Inmediato
            </span>
          </div>
        </section>

        {/* FAQ */}
        <section className="mb-16" data-id="element-143">
          <h3 className="text-2xl font-bold text-center mb-8 text-slate-800" data-id="element-144">
            Preguntas Frecuentes
          </h3>
          <div className="space-y-2" data-id="element-145">
            <AccordionItem title="¿Sirve para Argentina?" data-id="element-146">
              <p data-id="element-147">
                Sí, está 100% adaptado a la normativa, escalas y valores de
                Argentina (ARCA/AFIP).
              </p>
            </AccordionItem>
            <AccordionItem title="¿Necesito saber de programación o Excel avanzado?" data-id="element-148">
              <p data-id="element-149">
                No, las planillas vienen listas para usar. Solo cargas los datos
                básicos y las fórmulas hacen el resto.
              </p>
            </AccordionItem>
            <AccordionItem title="¿Cómo recibo el producto?" data-id="element-150">
              <p data-id="element-151">
                El acceso es inmediato. Una vez confirmado el pago, recibirás un
                email con el link para descargar todo el material.
              </p>
            </AccordionItem>
            <AccordionItem title="¿Hay que pagar mensualidad?" data-id="element-152">
              <p data-id="element-153">
                No, es un pago único con acceso de por vida a las herramientas y
                sus actualizaciones.
              </p>
            </AccordionItem>
          </div>
        </section>

        {/* Footer Support */}
        <footer className="text-center pb-8" data-id="element-154">
          <div className="flex items-center justify-center gap-2 text-gray-600 mb-2" data-id="element-155">
            <Settings className="w-5 h-5" data-id="element-156" />
            <span className="font-medium" data-id="element-157">Soporte Técnico</span>
          </div>
          <a href="mailto:EbookDreamShop@gmail.com" className="text-blue-600 hover:underline font-bold" data-id="element-158">
            EbookDreamShop@gmail.com
          </a>
        </footer>
      </main>
    </div>;
}